import React, { useContext, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { developAxios } from "../axios.config";
import { WeeklyContext } from "../Context/WeeklyContext";
const GetAssignmentTypes = () => {
	const params = useParams();
	const id = params._id;
	console.log(id, "ye hai params ki id");
	const {
		assignmentType,
		setAssignmentType,
		assignmentIdType,
		setAssignmentIdType,
		assignmentNameType,
		setAssignmentNameType,
	} = useContext(WeeklyContext);

	useEffect(() => {
		developAxios(localStorage.getItem("token"))
			.get(`pd-online/getAssignmentTypes/${id}`)
			.then(({ data }) => {
				console.log(data.data[0].cardName, "deepesh");
				setAssignmentType(data.data);
			})
			.catch((e) => {
				console.log(e);
			});
	}, []);
	console.log(assignmentType, "hel");
	const handleClick = async () => {
		await developAxios(localStorage.getItem("token"))
			.put(`/pd-online/addAssignmentType`, {
				_id: assignmentIdType,
				assignmentName: assignmentNameType,
			})
			.then(({ data }) => {
				console.log(data);
			})
			.catch((e) => {
				console.log(e);
			});
	};
	const handleChange = (e) => {
		setAssignmentIdType(e.target.value);
		console.log(e.target.value);
	};
	const handleAssignment = (e) => {
		setAssignmentNameType(e.target.value);
	};

	const name = ["Home Assignment", "Class Assignment"];
	return (
		<div>
			{assignmentType.map((ele) => {
				return (
					<>
						<div className="flex items-center justify-center mt-10">
							<p className="font-semibold ">{ele.cardName}</p>
						</div>

						<Link
							className="flex items-center justify-center"
							to={`get-assignment-questions${id}/${ele._id}`}
						>
							{" "}
							<button
								className="rounded-full
              bg-sky-500 hover:bg-sky-700 py-2 px-4 text-stone-50	mt-2 "
							>
								Get Assignment Questions
							</button>
						</Link>
					</>
				);
			})}

			<div className="flex flex-col content-center items-center		">
				<p className="font-bold mt-5">Add Assignment Type</p>
				<select
					className="  block
          w-full
          px-3
          py-1.5
          text-base
          font-normal
          text-gray-700
          bg-white bg-clip-padding bg-no-repeat
          border border-solid border-gray-300
          rounded
          transition
          ease-in-out
          mb-5
         1/2 w-
          focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
					aria-label="Default select example"
					onChange={handleChange}
					style={{ width: "400px" }}
				>
					<option>types</option>
					<option value={id}>{id}</option>
				</select>

				<select
					className="  block
          w-full
          px-3
          py-1.5
          text-base
          font-normal
          text-gray-700
          bg-white bg-clip-padding bg-no-repeat
          border border-solid border-gray-300
          rounded
          transition
          ease-in-out
          mb-5
         1/2 w-
          focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
					aria-label="Default select example"
					onChange={handleAssignment}
					style={{ width: "400px" }}
				>
					{name.map((e) => {
						return <option value={e}>{e}</option>;
					})}
				</select>
				<button
					onClick={handleClick}
					className="rounded-full
         bg-sky-500 hover:bg-sky-700 py-2 px-4 text-stone-50	mt-3 "
				>
					Add{" "}
				</button>

				<Link to="get-all-questions">
					{" "}
					<button
						className="rounded-full
           bg-sky-500 hover:bg-sky-700 py-2 px-4 text-stone-50	mt-20 "
					>
						Get All Questions
					</button>
				</Link>
			</div>
		</div>
	);
};

export default GetAssignmentTypes;
